// French strings of the Atelier (web/ui/atelier.js and web/ui/atelier/*.js). Registered at module
// load; keys are prefixed "atl." so they never collide with the shell dictionary.
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  // Sheet
  'atl.eyebrow': 'RÉSERVÉ À L’ADMINISTRATEUR',
  'atl.subtitle': 'Faites évoluer l’application en discutant avec Claude Code',
  'atl.subtitleRepo': 'Branche « {branch} » · modèle {model}',
  'atl.help': 'Comment fonctionne l’Atelier ?',
  'atl.loading': 'Chargement…',
  'atl.retry': 'Réessayer',
  'atl.refresh': 'Actualiser',
  'atl.views': 'Sections de l’Atelier',
  'atl.view.sessions': 'Sessions',
  'atl.view.chat': 'Conversation',
  'atl.view.changes': 'Modifications',

  // Availability
  'atl.unavailable.title': 'Atelier indisponible',
  'atl.unavailable.soon': 'L’Atelier n’est pas encore disponible sur ce serveur.',
  'atl.unavailable.repo': 'Atelier indisponible : le serveur n’est pas un dépôt git propre.',
  'atl.unavailable.repoHint': 'Les modifications en attente sur le Mac mini doivent d’abord être enregistrées ou annulées (git status dans le dossier du bureau). Vous pouvez toujours relire les sessions passées.',
  'atl.unavailable.readOnly': 'Vous pouvez toujours relire les sessions passées.',
  'atl.unavailable.disabled': 'L’Atelier est désactivé sur ce serveur (réglage atelier.enabled).',
  'atl.mock': 'Mode simulation (OFFICE_ENGINE=mock) : Claude est simulé et APPLIQUER est désactivé, pour ne rien fusionner ni envoyer par erreur.',
  'atl.noDeploy': 'Aucune commande de déploiement n’est réglée (atelier.deployCommand) : la modification sera fusionnée et envoyée sur GitHub, mais le bureau ne redémarrera pas tout seul.',

  // Intro banner
  'atl.intro.title': 'L’Atelier modifie le vrai code du bureau',
  'atl.intro.1': 'Décrivez en français ce que vous voulez changer dans l’application. Claude Code lit le code, le modifie et vous explique ce qu’il a fait.',
  'atl.intro.2': 'Il travaille dans une copie à part (une branche git) : le bureau en service n’est pas touché pendant ce temps.',
  'atl.intro.3': 'Relisez les modifications à droite, lancez TESTER, puis APPLIQUER ET DÉPLOYER. Rien ne change pour de vrai tant que vous n’avez pas appliqué.',
  'atl.intro.4': 'Appliquer enregistre la modification, l’envoie sur GitHub et le Mac mini la déploie : le bureau redémarre tout seul.',
  'atl.intro.ok': 'J’AI COMPRIS',

  // Sessions
  'atl.sessions.title': 'Sessions',
  'atl.sessions.new': 'NOUVELLE SESSION',
  'atl.sessions.empty': 'Aucune session pour l’instant. Décrivez votre première modification.',
  'atl.sessions.error': 'Liste des sessions indisponible.',
  'atl.sessions.newItem': 'Nouvelle session',
  'atl.sessions.newHint': 'Décrivez la modification',
  'atl.sessions.by': 'par {name}',

  // States
  'atl.state.running': 'CLAUDE TRAVAILLE',
  'atl.state.ready': 'PRÊTE',
  'atl.state.testing': 'TESTS EN COURS',
  'atl.state.applied': 'APPLIQUÉE',
  'atl.state.discarded': 'ABANDONNÉE',
  'atl.state.failed': 'ÉCHEC',
  'atl.state.applying': 'APPLICATION…',
  'atl.state.discarding': 'ABANDON…',
  'atl.state.unknown': 'INCONNU',

  // Conversation
  'atl.chat.newTitle': 'Nouvelle session',
  'atl.chat.newText': 'Décrivez ce que vous voulez changer : un libellé, une couleur, un nouveau bouton, un comportement… Soyez précis, comme pour un développeur.',
  'atl.chat.examples': 'Exemples',
  'atl.chat.example.1': 'Dans la barre du haut, affiche l’heure avec les secondes.',
  'atl.chat.example.2': 'Ajoute un bouton « Tout valider » dans le panneau À valider.',
  'atl.chat.example.3': 'Le compteur de tâches du service devrait aussi compter les échecs du jour.',
  'atl.chat.you': 'Vous',
  'atl.chat.claude': 'Claude',
  'atl.chat.steps': { one: '{n} étape', other: '{n} étapes' },
  'atl.chat.working': 'Claude travaille…',
  'atl.chat.workingHint': 'Il lit le code, le modifie et lance les vérifications. Cela peut prendre plusieurs minutes ; vous pouvez fermer l’Atelier, le travail continue.',
  'atl.chat.testing': 'Les tests tournent (npm test, jusqu’à 10 minutes)…',
  'atl.chat.applying': 'Application en cours…',
  'atl.chat.discarding': 'Abandon en cours…',
  'atl.chat.loadError': 'Session indisponible.',
  'atl.chat.error': 'Dernière erreur : {error}',
  'atl.chat.label': 'Votre demande',
  'atl.chat.placeholder': 'Que voulez-vous changer dans l’application ?',
  'atl.chat.placeholderFollow': 'Une précision, une correction, la suite ?',
  'atl.chat.send': 'ENVOYER',
  'atl.chat.start': 'LANCER',
  'atl.chat.shortcut': '⌘ ou Ctrl + Entrée pour envoyer',
  'atl.chat.counter': '{n} / {max}',
  'atl.chat.tooLong': 'Message trop long : {max} caractères au plus.',
  'atl.chat.empty': 'Décrivez d’abord ce que vous voulez changer.',
  'atl.chat.blocked.running': 'Claude travaille : attendez la fin pour envoyer un nouveau message.',
  'atl.chat.blocked.testing': 'Les tests tournent : attendez la fin pour envoyer un nouveau message.',
  'atl.chat.blocked.busy': 'Une opération est en cours sur cette session.',
  'atl.chat.blocked.applied': 'Session appliquée : ouvrez une nouvelle session pour une autre modification.',
  'atl.chat.blocked.discarded': 'Session abandonnée : ouvrez une nouvelle session.',
  'atl.chat.blocked.other': 'Claude travaille déjà sur une autre session : attendez la fin ou abandonnez-la.',
  'atl.chat.blocked.repo': 'Impossible d’ouvrir une session : le dépôt du serveur n’est pas prêt.',
  'atl.chat.blocked.disabled': 'L’Atelier est désactivé sur ce serveur.',
  'atl.chat.started': 'Session ouverte : Claude se met au travail.',

  // Changes
  'atl.changes.title': 'Modifications',
  'atl.changes.none': 'Aucune modification pour l’instant.',
  'atl.changes.noneHint': 'Les fichiers modifiés par Claude apparaîtront ici.',
  'atl.changes.pick': 'Choisissez ou ouvrez une session pour voir ses modifications.',
  'atl.changes.waiting': 'Les modifications s’afficheront quand Claude aura fini.',
  'atl.changes.discarded': 'Session abandonnée : ses modifications ont été supprimées.',
  'atl.changes.loadError': 'Diff indisponible : {error}',
  'atl.changes.stat': '{files} · +{ins} −{del}',
  'atl.changes.files': { one: '{n} fichier', other: '{n} fichiers' },
  'atl.changes.truncated': 'Le diff dépasse 400 Ko : la fin est coupée. Tous les fichiers modifiés restent listés.',
  'atl.changes.list': 'Fichiers modifiés',
  'atl.changes.expand': 'Afficher',
  'atl.changes.collapse': 'Masquer',
  'atl.changes.expandAria': 'Afficher le diff de {path}',
  'atl.changes.collapseAria': 'Masquer le diff de {path}',
  'atl.changes.lines': { one: '{n} ligne', other: '{n} lignes' },
  'atl.changes.binary': 'Fichier binaire : aperçu indisponible.',
  'atl.changes.noContent': 'Rien à afficher (fichier vide ou droits modifiés).',
  'atl.changes.notInPatch': 'Absent du diff affiché (coupé à 400 Ko).',
  'atl.changes.status.added': 'AJOUTÉ',
  'atl.changes.status.modified': 'MODIFIÉ',
  'atl.changes.status.deleted': 'SUPPRIMÉ',
  'atl.changes.status.renamed': 'RENOMMÉ',
  'atl.changes.status.copied': 'COPIÉ',
  'atl.changes.status.typechange': 'TYPE CHANGÉ',
  'atl.changes.status.unmerged': 'CONFLIT',
  'atl.changes.applied': 'Appliquée {when} : commit {commit}.',
  'atl.changes.pushOk': 'Envoyée sur « {remote} ».',
  'atl.changes.pushFailed': 'Non envoyée : {error}',
  'atl.changes.deployStarted': 'Déploiement lancé {when}.',
  'atl.changes.deployFailed': 'Déploiement non lancé : {error}',
  'atl.changes.forced': 'Appliquée sans tests réussis (forcée).',

  // Tests
  'atl.tests.title': 'Tests',
  'atl.tests.none': 'Pas encore lancés sur cette version.',
  'atl.tests.running': 'npm test tourne dans la copie de travail (jusqu’à 10 minutes)…',
  'atl.tests.ok': 'RÉUSSIS',
  'atl.tests.failed': 'EN ÉCHEC',
  'atl.tests.at': '{when}',
  'atl.tests.tail': 'Fin de la sortie ({n} dernières lignes)',
  'atl.tests.full': 'Toute la sortie',
  'atl.tests.showFull': 'Afficher toute la sortie',
  'atl.tests.showTail': 'Afficher seulement la fin',
  'atl.tests.empty': '(aucune sortie)',

  // Actions
  'atl.action.test': 'TESTER',
  'atl.action.apply': 'APPLIQUER ET DÉPLOYER',
  'atl.action.discard': 'ABANDONNER',
  'atl.action.testStarted': 'Tests lancés : le résultat s’affichera ici.',
  'atl.action.why.final': 'Session terminée.',
  'atl.action.why.busy': 'Attendez la fin de l’opération en cours.',
  'atl.action.why.failed': 'La dernière exécution a échoué : envoyez un nouveau message à Claude ou abandonnez la session.',
  'atl.action.why.tests': 'Lancez d’abord TESTER : les tests doivent réussir avant d’appliquer.',
  'atl.action.why.mock': 'Désactivé en mode simulation.',
  'atl.action.why.empty': 'Aucune modification à appliquer.',

  // Apply modal
  'atl.apply.title': 'Appliquer et déployer ?',
  'atl.apply.intro': 'Voici ce qui va se passer :',
  'atl.apply.step1': 'Les modifications sont enregistrées dans un commit « Atelier : {title} ».',
  'atl.apply.step2': 'Le commit est fusionné dans la branche « {branch} » du bureau puis envoyé sur GitHub ({remote}).',
  'atl.apply.step3': 'Le Mac mini déploie automatiquement la nouvelle version : reconstruction, tests, redémarrage. Si elle ne démarre pas, il revient à la version précédente.',
  'atl.apply.step4': 'Le bureau redémarre : cette page se reconnectera toute seule au bout de quelques instants.',
  'atl.apply.testsOk': 'Tests réussis {when}.',
  'atl.apply.testsNone': 'Les tests n’ont pas été lancés sur cette version.',
  'atl.apply.testsFailed': 'Les derniers tests ont échoué.',
  'atl.apply.advanced': 'Options avancées',
  'atl.apply.message': 'Titre du commit',
  'atl.apply.messageHint': 'Par défaut : le titre de la session.',
  'atl.apply.force': 'Forcer sans tests réussis',
  'atl.apply.forceHint': 'Déconseillé : applique même si les tests n’ont pas réussi. À réserver aux cas où les tests échouent pour une raison sans rapport avec la modification.',
  'atl.apply.confirm': 'APPLIQUER ET DÉPLOYER',
  'atl.apply.needTests': 'Lancez d’abord TESTER, ou cochez « Forcer » dans les options avancées.',
  'atl.apply.done': 'Modification appliquée.',
  'atl.apply.deploy': 'Déploiement lancé : le bureau va redémarrer.',

  // Discard
  'atl.discard.title': 'Abandonner cette session ?',
  'atl.discard.text': 'Les modifications de cette session seront supprimées (copie de travail et branche). Le bureau en service n’est pas touché. Cette action est irréversible.',
  'atl.discard.running': 'Claude travaille encore : il sera arrêté.',
  'atl.discard.confirm': 'ABANDONNER',
  'atl.discard.done': 'Session abandonnée.',
});
